import 'angular';
import { DidYouKnowMessagesService } from '../tutorial/DidYouKnowMessagesService';

interface OneTimeInitializationService {
    initAll: () => ng.IPromise<Object>;
}

OneTimeInitializationServiceFactory.$inject = ['FeatureManagerService', 
    '$q', 
    'authenticatedUser',
    'ClientMetricsService',
    'DidYouKnowMessagesService', 
    'PreferencesService'];
function OneTimeInitializationServiceFactory(
    FeatureManagerService, 
    $q: ng.IQService,
    authenticatedUser,
    ClientMetricsService,
    didYouKnowMessagesService: DidYouKnowMessagesService,
    PreferencesService): OneTimeInitializationService {

    let initComplete = false;
    let pendingInitPromise: ng.IPromise<Object> = null;
    const service: OneTimeInitializationService = {
        initAll: () => {
            if (initComplete) {
                return $q.when({});
            }
            //If there's already initialization in progress, return that promise.
            if (pendingInitPromise) {
                return pendingInitPromise;
            }

            // Initialization starts
            ClientMetricsService.setUserInfo(authenticatedUser.getUserInfo());
            pendingInitPromise = $q.all([
                //List all the services that needs to be initialized here for an app load

                //DidYouMessagesService depends on FeatureManagerService
                FeatureManagerService.getEnabledFeatureMap().then(didYouKnowMessagesService.init),
                PreferencesService.init()

            ]).then((data) => {
                initComplete = true;
                return data;
            });
            pendingInitPromise.finally(() => {
                pendingInitPromise = null;
            });
            return pendingInitPromise;
        }
    };
    return service;
}


angular.module('GorillaBoy.services')
    .factory('OneTimeInitializationService', OneTimeInitializationServiceFactory);


export {
    OneTimeInitializationService
};
